// extracted by mini-css-extract-plugin
export default {"home":"c-i_co","home__background":"c-i_cp","home__content":"c-i_cq"};